'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var Typography = require('../../../node_modules/@material-ui/core/esm/Typography/Typography.js');
var Divider$1 = require('../../../node_modules/@material-ui/core/esm/Divider/Divider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"]({
  container: {
    width: '100%',
    textAlign: 'center',
    borderBottom: '1px solid #e0e0e0',
    lineHeight: '1px',
    margin: 0
  },
  span: {
    background: '#fff',
    padding: '0 10px',
    color: '#999'
  }
});

var Divider = function Divider(_ref) {
  var children = _ref.children,
      props = objectWithoutProperties(_ref, ["children"]);

  var _useStyles = useStyles(),
      container = _useStyles.container,
      span = _useStyles.span;

  if (children) {
    return React__default["default"].createElement(Typography["default"], {
      className: container
    }, children && React__default["default"].createElement("span", {
      className: span
    }, children));
  }

  return React__default["default"].createElement(Divider$1["default"], _objectSpread({}, props));
};

module.exports = Divider;
